export function getTenantName(aliases, tenantId, tenant_details) {
  const alias = aliases.find((a) => a.tenantId === tenantId)
  return (
    (alias && alias.name) ||
    (tenant_details && tenant_details.firstName && tenant_details.lastName
      ? tenant_details.firstName + ' ' + tenant_details.lastName
      : tenant_details && tenant_details.username) ||
    ''
  )
}
